import { Card, CardActionArea, CardContent, CardMedia, Grid, Typography } from '@material-ui/core';
import React, { Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TitleSection } from '../Typography';
import IconsFilter from '../../utils/IconsFilter';
import { NavLink } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        marginBottom: 91,
        '&:hover': { 
            color: '#FFFFFF'
         },
    },
    cardContainer : {
        boxShadow: 0,
        '&:hover': { 
            color: '#FFFFFF'
         },
    },
    card:{
        backgroundColor: '#FFF',
        boxShadow: 'none',
        height: 200,
        '&:hover': { 
            color: '#FFFFFF'
         },
    },
    media: {
        height: 64,
        width: 64,
        margin: '0 auto',
        borderWidth: 1,
        borderColor: '#754795'
    },
    content: {
        textAlign: 'center',
        '&:hover': { 
            color: '#FFFFFF'
         },
    },
    cardAction:{
        paddingLeft: 21,
        paddingRight: 21,
        paddingTop: 49,
        paddingBottom: 42,
        '&:hover': { 
            backgroundColor: theme.palette.primary.main,
            textDecoration: 'none',
            color: '#FFFFFF',
            '& h6' : {
                color: '#fff'
            }
         },
    },
    link:{
        '&:hover': { 
            //backgroundColor: theme.palette.primary.main,
            textDecoration: 'none',
            color: '#FFFFFF'
        },
    },
    title:{
        lineHeight: 1,
        color:'#989898',
        '&:hover': { 
            color: '#FFFFFF'
         },
    },
  
}));

const Categorys = ({itens=[], ...props}) => {
        const classes = useStyles(props);

        return(
            <Fragment>
                <TitleSection text="Categorias" />
                <div className={classes.root}>
                    <Grid container spacing={1} >
                    {
                        itens.map((category, index) => {
                            const icon = IconsFilter(category.name);
                            return(
                                <Grid key={index} item xs={6} sm={2} className={classes.cardContainer}>
                                    <Card className={classes.card} >
                                        <NavLink className={classes.link} to={`/categoria/${category.url}`}>
                                            <CardActionArea component="div" disableRipple className={classes.cardAction}>
                                                <CardMedia
                                                    className={classes.media}
                                                    image={icon}
                                                    title={category.name}
                                                />
                                                <CardContent className={classes.content} >
                                                    <Typography variant="subtitle1" className={classes.title}>
                                                    {category.name}
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                        </NavLink>
                                    </Card>
                                </Grid>
                            )
                        })
                    }
                    </Grid>
                </div>
            </Fragment>
        );
}

export default Categorys;